export default {
    state: {
        childBoms: [],
    },

    actions: {

        async fetchChildBoms(ctx, superBomID) {
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const res = await fetch(
                "/api/batchsize/?super_bom_flag=false&same_quote_as_bom=" + superBomID, requestParams);
            let childBoms = await res.json();
            childBoms = childBoms.filter(bom => bom.super_bom == superBomID || bom.super_bom === null)
            for (let childBom of childBoms) {
                if (childBom.super_bom == superBomID) {
                    childBom.vgtSelected = true
                }
            }
            ctx.commit('updateChildBoms', childBoms)
        },
        async saveChildBoms(ctx, childBoms) {
            ctx.commit('updateChildBoms', childBoms)
        },
        async actionDeleteBomFromSuperBom(ctx, row) {
            // TODO: replace row on superBomId
            const superBoms = JSON.parse(JSON.stringify(ctx.state.superBoms))
            let superBom = superBoms.filter(bom => bom.id === row.super_bom)[0]
            superBom.children = superBom.children.filter(batchSize => batchSize.id !== row.id)
            const requestUpdateBatchSize = {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
                body: JSON.stringify({
                    'super_bom': null,
                })
            };
            await fetch("/api/batchsize/" + row.id + "/", requestUpdateBatchSize).then(_ => {
                ctx.commit('updateSuperBoms', superBoms)
            })
        },

    },

    mutations: {
        async updateChildBoms(state, childBoms) {
            state.childBoms = childBoms
        },
    },

    getters: {
        bomSameQuote(state) {
            return state.childBoms
        },
    }
}